/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventInitiatorCountResponse
 */
export interface AuditEventInitiatorCountResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditEventInitiatorCountResponse
     */
    initiator?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventInitiatorCountResponse
     */
    count?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventInitiatorCountResponse
     */
    failedCount?: any | null;
}

/**
 * Check if a given object implements the AuditEventInitiatorCountResponse interface.
 */
export function instanceOfAuditEventInitiatorCountResponse(value: object): value is AuditEventInitiatorCountResponse {
    return true;
}

export function AuditEventInitiatorCountResponseFromJSON(json: any): AuditEventInitiatorCountResponse {
    return AuditEventInitiatorCountResponseFromJSONTyped(json, false);
}

export function AuditEventInitiatorCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventInitiatorCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'initiator': json['initiator'] === undefined ? undefined : json['initiator'] === null ? null : json['initiator'],
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
        'failedCount': json['failedCount'] === undefined ? undefined : json['failedCount'] === null ? null : json['failedCount'],
    };
}

export function AuditEventInitiatorCountResponseToJSON(json: any): AuditEventInitiatorCountResponse {
    return AuditEventInitiatorCountResponseToJSONTyped(json, false);
}

export function AuditEventInitiatorCountResponseToJSONTyped(value?: AuditEventInitiatorCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiator': value['initiator'],
        'count': value['count'],
        'failedCount': value['failedCount'],
    };
}

